export default function Contact() {
  return (
    <section>
     
    </section>
  );
}
